import * as Yup from 'yup'

const createForgotPasswordSchema = t =>
  Yup.object().shape({
    email: Yup.string().email(t('auth.login.validation.emailInvalid')).required(t('auth.forgotPassword.validation.emailRequired')),
  })

export default createForgotPasswordSchema
